import { Page, BlockTitle } from 'framework7-react';
import EducationalVideosList from '@components/EducationalVideos/EducationalVideosList';
import { BottomTabBar } from '@components/BottomTabBar';
import '@styles/learn.css';

function LearnView() {
  return (
    <Page name="learn">
      {/* <Navbar>
        <NavTitle>Learn</NavTitle>
      </Navbar> */}

      <BlockTitle className="learn-block-title">Educational Videos</BlockTitle>
      <EducationalVideosList />

      <BottomTabBar />
    </Page>
  );
}

export default LearnView;
